import { render, staticRenderFns } from "./DashboardDetailTransaction.vue?vue&type=template&id=4321f4a3"
import script from "./DashboardDetailTransaction.vue?vue&type=script&lang=js"
export * from "./DashboardDetailTransaction.vue?vue&type=script&lang=js"
import style0 from "./DashboardDetailTransaction.vue?vue&type=style&index=0&id=4321f4a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports